var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckDataAnalyzerText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 656.99 68.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.4,174.27v38.67H375.32V174.27H364.88v-9.36h32v9.36Z",
    transform: "translate(-364.88 -160.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.5,180.82h10.37v5a11.37,11.37,0,0,1,4-4.46,10,10,0,0,1,5.55-1.37,10.4,10.4,0,0,1,3.38.5l-.58,9.72a9.76,9.76,0,0,0-4.68-1.15,6.76,6.76,0,0,0-5.18,2.16c-2.31,2.45-2.52,5.91-2.52,8.64v13H398.5Z",
    transform: "translate(-364.88 -160.44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.52,180.82v17.71c0,1.44.14,3.68,1.8,5.19a6.09,6.09,0,0,0,4.32,1.51,6.46,6.46,0,0,0,4.39-1.51c1.51-1.44,1.73-3.6,1.73-5.19V180.82h10.37v18.72c0,3.67-.36,7.13-3.6,10.3-3.68,3.6-9.08,4.18-12.89,4.18s-9.29-.58-13-4.18c-2.95-2.88-3.52-6.12-3.52-9.65V180.82Z",
    transform: "translate(-364.88 -160.44)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.31,191a10.4,10.4,0,0,0-6.77-2.45,8.22,8.22,0,0,0-5.9,2.31,8.47,8.47,0,0,0-2.38,6,8.31,8.31,0,0,0,2.16,5.76,8.52,8.52,0,0,0,6.26,2.59,10.12,10.12,0,0,0,6.63-2.52v9.36a16.08,16.08,0,0,1-8.21,2,17.26,17.26,0,0,1-12.46-4.83,16.74,16.74,0,0,1-5-12.24,17.27,17.27,0,0,1,5.33-12.67,17.09,17.09,0,0,1,12.24-4.54,18.27,18.27,0,0,1,8.14,1.8Z",
    transform: "translate(-364.88 -160.44)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.88,160.44v32.19l11.66-11.81h13.61l-15.27,14.55,16.35,17.57h-14l-12.38-13.83v13.83H498.51v-52.5Z",
    transform: "translate(-364.88 -160.44)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.16,164.91c6.34,0,13,.93,18.94,6.62,4.25,4.11,6.91,9.72,6.91,17.21s-2.59,13-6.55,17c-6.62,6.7-14.91,7.21-18.94,7.21H557v-48Zm-4.1,38.66h3c2.3,0,7.34-.21,11-3.24,2.59-2.16,4.68-6.26,4.68-11.59a14.23,14.23,0,0,0-4-10.37c-3.61-3.6-8.29-4.1-11.67-4.1h-3Z",
    transform: "translate(-364.88 -160.44)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.69,180.82h10.37v32.12H629.69v-3.89a10.7,10.7,0,0,1-9.5,5c-4.61,0-8.5-1.16-12-4.9a17,17,0,0,1-4.68-12,18.29,18.29,0,0,1,5-13,15.48,15.48,0,0,1,11.16-4.39,12,12,0,0,1,10.08,4.68ZM616.51,191a8,8,0,0,0-2.37,5.84,8.27,8.27,0,0,0,2.16,5.76,8.52,8.52,0,0,0,6.12,2.52,7.68,7.68,0,0,0,5.4-2.24A8.51,8.51,0,0,0,628,190.9a8.68,8.68,0,0,0-5.76-2.23A8.17,8.17,0,0,0,616.51,191Z",
    transform: "translate(-364.88 -160.44)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M658.78,189.17v23.77H648.41V189.17h-3.6v-8.35h3.6V170.45h10.37v10.37h6.41v8.35Z",
    transform: "translate(-364.88 -160.44)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.27,180.82h10.37v32.12H694.27v-3.89a10.69,10.69,0,0,1-9.5,5c-4.61,0-8.5-1.16-12-4.9a17,17,0,0,1-4.68-12,18.29,18.29,0,0,1,5-13,15.48,15.48,0,0,1,11.16-4.39,12,12,0,0,1,10.08,4.68ZM681.1,191a8,8,0,0,0-2.38,5.84,8.27,8.27,0,0,0,2.16,5.76,8.52,8.52,0,0,0,6.12,2.52,7.68,7.68,0,0,0,5.4-2.24,8.53,8.53,0,0,0,.15-11.95,8.7,8.7,0,0,0-5.76-2.23A8.14,8.14,0,0,0,681.1,191Z",
    transform: "translate(-364.88 -160.44)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758.93,203.86H740.78l-3.67,9.08H725.59l19.37-48h10.15l18.94,48H762.53Zm-3-8.49L750,179.24l-6,16.13Z",
    transform: "translate(-364.88 -160.44)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.22,180.82h10.37v3.82a11.71,11.71,0,0,1,9.94-4.68c2.8,0,6.48.5,9.21,3.24,3,3,3.24,6.84,3.24,9.43v20.31H800.62V196.45c0-2.09-.08-4.76-1.73-6.41a5.46,5.46,0,0,0-4-1.44,5.61,5.61,0,0,0-4.32,1.73c-1.73,1.72-2,4-2,6.12v16.49H778.22Z",
    transform: "translate(-364.88 -160.44)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.67,180.82H854v32.12H843.67v-3.89a10.7,10.7,0,0,1-9.5,5c-4.61,0-8.5-1.16-12-4.9a17,17,0,0,1-4.68-12,18.29,18.29,0,0,1,5-13,15.47,15.47,0,0,1,11.16-4.39,12,12,0,0,1,10.08,4.68ZM830.49,191a8,8,0,0,0-2.37,5.84,8.27,8.27,0,0,0,2.16,5.76,8.52,8.52,0,0,0,6.12,2.52,7.68,7.68,0,0,0,5.4-2.24,8.51,8.51,0,0,0,.14-11.95,8.68,8.68,0,0,0-5.76-2.23A8.17,8.17,0,0,0,830.49,191Z",
    transform: "translate(-364.88 -160.44)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.76,160.44v52.5H862.39v-52.5Z",
    transform: "translate(-364.88 -160.44)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M892.56,208.83l-15.34-28h11.95l9.07,17.43,8.86-17.43h11.67l-25.85,48.6H881.25Z",
    transform: "translate(-364.88 -160.44)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M937.63,204.29h15.19v8.65H920.06l16.7-23.48H922.58v-8.64h31.68Z",
    transform: "translate(-364.88 -160.44)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.06,198.68h-24a8.75,8.75,0,0,0,1.95,5.47,6.94,6.94,0,0,0,5.32,2,8.49,8.49,0,0,0,4.18-.94,6.25,6.25,0,0,0,2.23-2.66l9.8,1a14.33,14.33,0,0,1-6.2,8.07A19.07,19.07,0,0,1,975.21,214c-4.82,0-9.07-.87-12.82-4.61A17.3,17.3,0,0,1,957.57,197a18.28,18.28,0,0,1,4.9-12.67c3.88-3.89,8.71-4.61,12.31-4.61s8.78.65,12.74,4.82,4.54,9.08,4.54,13Zm-9.58-6.19a8.12,8.12,0,0,0-2.08-3.75,7.62,7.62,0,0,0-10.16.29,7.2,7.2,0,0,0-1.8,3.46Z",
    transform: "translate(-364.88 -160.44)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.54,180.82h10.37v5a11.37,11.37,0,0,1,4-4.46,9.94,9.94,0,0,1,5.54-1.37,10.42,10.42,0,0,1,3.39.5l-.58,9.72a9.79,9.79,0,0,0-4.68-1.15,6.75,6.75,0,0,0-5.18,2.16c-2.31,2.45-2.52,5.91-2.52,8.64v13H998.54Z",
    transform: "translate(-364.88 -160.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDataAnalyzerText);
export default __webpack_public_path__ + "static/media/TruckDataAnalyzerText.864bc2174115809e71138349bb57bfca.svg";
export { ForwardRef as ReactComponent };